/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlannerSessionUpdateRequest
 */
export interface PlannerSessionUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PlannerSessionUpdateRequest
     */
    name: string;
}

/**
 * Check if a given object implements the PlannerSessionUpdateRequest interface.
 */
export function instanceOfPlannerSessionUpdateRequest(value: object): value is PlannerSessionUpdateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PlannerSessionUpdateRequestFromJSON(json: any): PlannerSessionUpdateRequest {
    return PlannerSessionUpdateRequestFromJSONTyped(json, false);
}

export function PlannerSessionUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerSessionUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function PlannerSessionUpdateRequestToJSON(json: any): PlannerSessionUpdateRequest {
    return PlannerSessionUpdateRequestToJSONTyped(json, false);
}

export function PlannerSessionUpdateRequestToJSONTyped(value?: PlannerSessionUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

